export default "__VITE_ASSET__CngN_Xt___"